import React, { useState } from 'react';

import styles from './yamlEditor.module.scss';

function YamlAnyOf({ yamlSchema, elementList, path }: any) {
  const [currentChoiceIndex, setCurrentChoiceIndex] = useState<number>(-1);
  return (
    <>
      <div className={styles.dataTypeTag}>Any of</div>
      {elementList.map((elem: any, index: number) => (
        <div
          key={`idx_${index}`}
          className={index == currentChoiceIndex ? styles.choiceTagActive : styles.choiceTag}
          onClick={() => setCurrentChoiceIndex(index == currentChoiceIndex ? -1 : index)}
        >
          {elem.title || index}
        </div>
      ))}
      {currentChoiceIndex >= 0 && currentChoiceIndex < elementList.length && (
        <div className={styles.indentor}>
          <YamlElement
            yamlSchema={yamlSchema}
            element={elementList[currentChoiceIndex]}
            path={`${path}/${currentChoiceIndex}`}
          />
        </div>
      )}
    </>
  );
}

function YamlElement({ yamlSchema, element, path }: { yamlSchema: any; element: any; path: string }) {
  if (element.type == 'object')
    return (
      <>
        <div className={styles.dataTypeTag}>Object</div>
        <br />
        <div>
          <i>{element.description}</i>
        </div>
        <div className={styles.indentor}>
          {element.properties &&
            Object.keys(element.properties).map((propKey) => (
              <div key={propKey} style={{ margin: '12px 0' }}>
                <code>
                  <b>{propKey}:</b>
                </code>
                &nbsp;
                {element.required && element.required.indexOf(propKey) >= 0 && <span> &#10003; </span>}
                <YamlElement
                  yamlSchema={yamlSchema}
                  element={element.properties[propKey]}
                  path={`${path}/${propKey}`}
                />
              </div>
            ))}
          {element.additionalProperties && (
            <>
              <code>
                <b>[Key]:</b>
              </code>
              <YamlElement yamlSchema={yamlSchema} element={element.additionalProperties} path={`${path}/ANY`} />
            </>
          )}
        </div>
      </>
    );

  if (element.type == 'array')
    return (
      <>
        <div>
          <i>{element.description}</i>
        </div>
        <div className={styles.dataTypeTag}>Array of</div>
        {element.items && <YamlElement yamlSchema={yamlSchema} element={element.items} path={`${path}/ARRAY`} />}
      </>
    );

  if (element.anyOf)
    return <YamlAnyOf yamlSchema={yamlSchema} elementList={element.anyOf} path={`${path}/MULTIPLECHOICE`} />;

  // Default handler - any other type (string, number...)
  return (
    <>
      <div className={styles.dataTypeTag}>
        {typeof element.type == 'string' ? element.type : JSON.stringify(element.type)}
      </div>
      {element.const && <code>{element.const}</code>}
      {element.enum && <code>{element.enum.map((el: any) => String(el)).join(', ')}</code>}
      {element.minimum !== undefined && element.maximum !== undefined && (
        <span>
          Range: {element.minimum} - {element.maximum}
        </span>
      )}
      <div>
        <i>{element.description}</i>
      </div>
    </>
  );

  return `Unknown: ${JSON.stringify(element)}`;
}

export interface TpYamlSchemaDocumentationProps {
  yamlSchema: any;
}

function YamlSchemaDocumentation({ yamlSchema }: TpYamlSchemaDocumentationProps) {
  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <YamlElement yamlSchema={yamlSchema} element={yamlSchema} path="" />
    </div>
  );
}

export default YamlSchemaDocumentation;
